import { Component } from '@angular/core';
import { FeatureConfigFacade } from '@common/data-access-feature-config';
import { fadeInOut } from '@common/ui-sales-components';
import { BuildConfigService, LoaderService } from '@common/util-foundation';
import { BuildConfig } from '@common/util-models';
import {
  NavigationLink,
  NavigationLinks,
} from '@domgen/dgx-fe-business-models';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ao-reinstate-app-root',
  templateUrl: './ao-reinstate-app.component.html',
  styleUrls: ['./ao-reinstate-app.component.scss'],
  animations: [fadeInOut],
})
export class AoReinstateAppComponent {
  config: BuildConfig = this.buildConfigService.config;
  headerNavigationLinks: NavigationLinks = this.config.header;
  loading$ = this.loaderService.loading$;
  clientLogoPath$ = this.featureConfigFacade
    .sidedoor$()
    .pipe(map((config) => config?.clientLogoPath));
  footerProtectLinks: NavigationLink[] = this.config.footer.links.filter(
    ({ section }) => section === 'protect'
  );
  footerUsefulLinks: NavigationLink[] = this.config.footer.links.filter(
    ({ section }) => section === 'useful'
  );
  footerLegalLinks: NavigationLink[] = this.config.footer.links.filter(
    ({ section }) => section === 'legal'
  );

  constructor(
    private readonly buildConfigService: BuildConfigService,
    private readonly loaderService: LoaderService,
    private featureConfigFacade: FeatureConfigFacade
  ) {}
}
